import React from 'react';
import useGetIntegrations from '../../requests/useGetIntegrations';
import QueryView from '../Common/QueryView';
import { useKaEmployee } from '../UserAccess/useKaEmployee';
import { Link } from 'react-router-dom';

export const EmployeeIntegrationPage = () => {
  const employee = useKaEmployee();
  const getIntegrations = useGetIntegrations(employee.selectedBusiness!.id);

  const ToEmployeeIntegrationUri = (uri: string) => {
    return uri.replace(/\.net/, '.net/kaEmployee');
  }

  return <QueryView
    query={getIntegrations}
    renderData={(data) => {
      return <>
        <h2 className='col-auto ka-blue mb-2'>Integrations</h2>
        {data.map(i =>
          <div className="mt-5">
            <h3>
              <Link
                target="_blank"
                to={ToEmployeeIntegrationUri(i.configurationUri)}>
                {i.name}
                <i className="bi bi-box-arrow-up-right ms-1"></i>
              </Link>
            </h3>
          </div> 
        )}
        {data.length === 0 &&
          <h3>No integrations available</h3>
        }
        <h2 className='col-auto ka-blue mb-2 mt-5 pt-5'>External Integrations</h2>
        <div className="mt-5">
          <h3>
            <Link to="/employee/apiEventLog">
              API Event Log
              <i className="bi bi-box-arrow-up-right ms-1"></i>
            </Link>
          </h3>
        </div>
      </>

    }}
  />
  
}


export default EmployeeIntegrationPage;
